import { useEffect } from 'react';
import { addListener, launch } from 'devtools-detector';

export function blockConsole({ clearConsole = true, enabled = true } = {}) {
  useEffect(() => {
    if (!enabled || typeof window === 'undefined' || typeof document === 'undefined') return;

    const OVERLAY_ID = '__devtools_lock2_overlay__';

    const lockScreen = () => {
      if (clearConsole) {
        try { console.clear(); } catch {}
      }
      if (document.getElementById(OVERLAY_ID)) return;

      const o = document.createElement('div');
      o.id = OVERLAY_ID;
      Object.assign(o.style, {
        position: 'fixed',
        inset: '0',
        background: '#fff',
        zIndex: '2147483647',
        pointerEvents: 'all',
      });

      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';

      document.body.appendChild(o);
    };

    const unlockScreen = () => {
      const o = document.getElementById(OVERLAY_ID);
      if (o?.parentNode) o.parentNode.removeChild(o);
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    };

    const remove = addListener((isOpen) => {
      if (isOpen) {
        lockScreen();
      } else {
        unlockScreen();
      }
    });

    launch();

    return () => {
      remove?.();
      unlockScreen();
    };
  }, [clearConsole, enabled]);
}



